function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".move_carina_active_svg__cls-1{fill:none;stroke:#6cff00}.move_carina_active_svg__cls-2{fill:#6cff00}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "move_carina_active_svg__Group_21663"
}, /*#__PURE__*/React.createElement("g", {
  id: "move_carina_active_svg__Group_21661",
  transform: "translate(0 5.197)"
}, /*#__PURE__*/React.createElement("path", {
  id: "move_carina_active_svg__Line_523",
  d: "M0 0v13.929",
  className: "move_carina_active_svg__cls-1",
  transform: "rotate(90 5.927 9.05)"
}), /*#__PURE__*/React.createElement("path", {
  id: "move_carina_active_svg__Polygon_549",
  d: "M3.057 0l3.057 3.057H0z",
  className: "move_carina_active_svg__cls-2",
  transform: "rotate(90 8.254 8.254)"
}), /*#__PURE__*/React.createElement("path", {
  id: "move_carina_active_svg__Polygon_548",
  d: "M3.057 0l3.057 3.057H0z",
  className: "move_carina_active_svg__cls-2",
  transform: "rotate(-90 3.057 3.057)"
})), /*#__PURE__*/React.createElement("g", {
  id: "move_carina_active_svg__Group_21674",
  transform: "rotate(90 5.655 5.655)"
}, /*#__PURE__*/React.createElement("path", {
  id: "move_carina_active_svg__Line_523-2",
  d: "M0 0v13.929",
  className: "move_carina_active_svg__cls-1",
  transform: "rotate(90 5.927 9.05)"
}), /*#__PURE__*/React.createElement("path", {
  id: "move_carina_active_svg__Polygon_549-2",
  d: "M3.057 0l3.057 3.057H0z",
  className: "move_carina_active_svg__cls-2",
  transform: "rotate(90 8.254 8.254)"
}), /*#__PURE__*/React.createElement("path", {
  id: "move_carina_active_svg__Polygon_548-2",
  d: "M3.057 0l3.057 3.057H0z",
  className: "move_carina_active_svg__cls-2",
  transform: "rotate(-90 3.057 3.057)"
})));
function SvgMoveCarinaActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "move_carina_active_svg__Component_116_169",
    width: 16.507,
    height: 16.507,
    viewBox: "0 0 16.507 16.507"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_116_169' width='16.507' height='16.507' viewBox='0 0 16.507 16.507'%3e %3cdefs%3e %3cstyle%3e .cls-1%7bfill:none;stroke:%236cff00%7d.cls-2%7bfill:%236cff00%7d %3c/style%3e %3c/defs%3e %3cg id='Group_21663'%3e %3cg id='Group_21661' transform='translate(0 5.197)'%3e %3cpath id='Line_523' d='M0 0L0 13.929' class='cls-1' transform='rotate(90 5.927 9.05)'/%3e %3cpath id='Polygon_549' d='M3.057 0l3.057 3.057H0z' class='cls-2' transform='rotate(90 8.254 8.254)'/%3e %3cpath id='Polygon_548' d='M3.057 0l3.057 3.057H0z' class='cls-2' transform='rotate(-90 3.057 3.057)'/%3e %3c/g%3e %3cg id='Group_21674' transform='rotate(90 5.655 5.655)'%3e %3cpath id='Line_523-2' d='M0 0L0 13.929' class='cls-1' transform='rotate(90 5.927 9.05)'/%3e %3cpath id='Polygon_549-2' d='M3.057 0l3.057 3.057H0z' class='cls-2' transform='rotate(90 8.254 8.254)'/%3e %3cpath id='Polygon_548-2' d='M3.057 0l3.057 3.057H0z' class='cls-2' transform='rotate(-90 3.057 3.057)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgMoveCarinaActive as ReactComponent };